import { Type } from 'class-transformer';

import { IPagination } from './utils';

export class ICityStatistics {
  id: string | number;
  @Type(() => Number)
  cityId: string | number;
  @Type(() => Number)
  adet: number;
  @Type(() => Number)
  desi: number;
  isActive: boolean;
}

export class ICityStatisticsListResponse extends IPagination {
  @Type(() => ICityStatistics)
  results: ICityStatistics[];
}

export class ICityStatisticsResponse extends IPagination {
  @Type(() => ICityStatistics)
  result: ICityStatistics;
}

export class ICityStatisticsById {
  @Type(() => Number)
  cityId: string | number;
  @Type(() => Number)
  count: number;
  @Type(() => Number)
  desi: number;
}

export class ICityStatisticsByIdListResponse extends IPagination {
  @Type(() => ICityStatistics)
  results: ICityStatisticsById[];
}

export class ICityStatisticsByCityId {
  @Type(() => Number)
  pointId: string | number;
  @Type(() => Number)
  count: number;
  @Type(() => Number)
  desi: number;
}

export class ICityStatisticsByCityIdListResponse extends IPagination {
  @Type(() => ICityStatistics)
  results: ICityStatisticsByCityId[];
}
